import PedidoEnderecoEntregaService from "@/services/PedidoEnderecoEntregaService";

export const pedidoEnderecoEntrega = {
  namespaced: true,
  state: {
    pedidoEnderecoEntrega: {},
  },
  actions: {
    getPedidoEnderecoEntrega({ commit }, payload) {
      return PedidoEnderecoEntregaService.GetPedidoEnderecoEntrega(
        payload
      ).then(
        (pedidoEnderecoEntrega) => {
          return Promise.resolve(pedidoEnderecoEntrega);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoEnderecoEntrega({ commit }, payload) {
      return PedidoEnderecoEntregaService.PostPedidoEnderecoEntrega(
        payload
      ).then(
        (pedidoEnderecoEntrega) => {
          return Promise.resolve(pedidoEnderecoEntrega);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoEnderecoEntrega({ commit }, payload) {
      return PedidoEnderecoEntregaService.PutPedidoEnderecoEntrega(
        payload
      ).then(
        (pedidoEnderecoEntrega) => {
          return Promise.resolve(pedidoEnderecoEntrega);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoEnderecoEntrega({ commit }, payload) {
      return PedidoEnderecoEntregaService.DeletePedidoEnderecoEntrega(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoEnderecoEntregaOData({ commit }, payload) {
      return PedidoEnderecoEntregaService.GetPedidoEnderecoEntregaOData(
        payload
      ).then(
        (pedidoEnderecoEntrega) => {
          return Promise.resolve(pedidoEnderecoEntrega);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoEnderecoEntrega;
